import { IconWaveSine } from "@tabler/icons-react";
import { CSSProperties, forwardRef } from "react";

import { colors } from "#app/theme/v1/colors";
import { radius } from "#app/theme/v1/radius";
import { spacing } from "#app/theme/v1/spacing";
import { Box } from "#shared/view/components/Box";

import AddFile from "./svg/add-file.svg?react";
import AddToQueue from "./svg/add-to-queue.svg?react";
import AlertTriangle from "./svg/alert-triangle.svg?react";
import ArrowBottom from "./svg/arrow-bottom.svg?react";
import ArrowLeft from "./svg/arrow-left.svg?react";
import ArrowRight from "./svg/arrow-right.svg?react";
import ArrowUp from "./svg/arrow-up.svg?react";
import Beam from "./svg/beam.svg?react";
import Billet from "./svg/billet.svg?react";
import Calendar from "./svg/calendar.svg?react";
import Chat from "./svg/chat.svg?react";
import Check from "./svg/check.svg?react";
import ChevronDown from "./svg/chevron-down.svg?react";
import ChevronLeft from "./svg/chevron-left.svg?react";
import ChevronRight from "./svg/chevron-right.svg?react";
import ChevronUp from "./svg/chevron-up.svg?react";
import CircleAlert from "./svg/circle-alert.svg?react";
import CircleCheck from "./svg/circle-check.svg?react";
import CircleError from "./svg/circle-error.svg?react";
import CircleFillAlert from "./svg/circle-fill-alert.svg?react";
import CircleFillCheck from "./svg/circle-fill-check.svg?react";
import CircleFillError from "./svg/circle-fill-error.svg?react";
import CircleFillInfo from "./svg/circle-fill-info.svg?react";
import CircleHelp from "./svg/circle-help.svg?react";
import CircleInfo from "./svg/circle-info.svg?react";
import CircleMinus from "./svg/circle-minus.svg?react";
import Circle from "./svg/circle.svg?react";
import Code from "./svg/code.svg?react";
import CommentDetail from "./svg/comment-detail.svg?react";
import Comment from "./svg/comment.svg?react";
import Csv from "./svg/csv.svg?react";
import Cube from "./svg/cube.svg?react";
import Cylinder from "./svg/cylinder.svg?react";
import Detail from "./svg/detail.svg?react";
import Dislike from "./svg/dislike.svg?react";
import Download from "./svg/download.svg?react";
import Duplicate from "./svg/duplicate.svg?react";
import Edit from "./svg/edit.svg?react";
import Ellipsis from "./svg/ellipsis.svg?react";
import Expand from "./svg/expand.svg?react";
import Export from "./svg/export.svg?react";
import Fabera from "./svg/fabera.svg?react";
import Factory from "./svg/factory.svg?react";
import FileBlank from "./svg/file-blank.svg?react";
import FileFind from "./svg/file-find.svg?react";
import File from "./svg/file.svg?react";
import FillDanger from "./svg/fill-danger.svg?react";
import Filter from "./svg/filter.svg?react";
import Frame from "./svg/frame.svg?react";
import Fullscreen from "./svg/fullscreen.svg?react";
import Grid from "./svg/grid.svg?react";
import GripVertical from "./svg/grip-vertical.svg?react";
import Hammer from "./svg/hammer.svg?react";
import Help from "./svg/help-circle.svg?react";
import HintArrow from "./svg/hint-arrow.svg?react";
import History from "./svg/history.svg?react";
import Home from "./svg/home.svg?react";
import Import from "./svg/import.svg?react";
import InfoCircle from "./svg/info-circle.svg?react";
import Intersect from "./svg/intersect.svg?react";
import Invoice from "./svg/invoice.svg?react";
import LayerPlus from "./svg/layer-plus.svg?react";
import Layer from "./svg/layer.svg?react";
import Layers3 from "./svg/layers-3.svg?react";
import Layout from "./svg/layout.svg?react";
import Light from "./svg/light.svg?react";
import Lightning from "./svg/lightning.svg?react";
import Like from "./svg/like.svg?react";
import Line from "./svg/line.svg?react";
import LinkExternal from "./svg/link-external.svg?react";
import Link from "./svg/link.svg?react";
import List from "./svg/list.svg?react";
import Lock from "./svg/lock.svg?react";
import Logout from "./svg/log-out.svg?react";
import MachiningIcon from "./svg/machining.svg?react";
import MailSend from "./svg/mail-send.svg?react";
import Mail from "./svg/mail.svg?react";
import Map from "./svg/map.svg?react";
import Menu from "./svg/menu.svg?react";
import MessageSquareEdit from "./svg/message-square-edit.svg?react";
import Message from "./svg/message.svg?react";
import Minus from "./svg/minus.svg?react";
import Model from "./svg/model.svg?react";
import MoreHorizontal from "./svg/more_horizontal.svg?react";
import Nut from "./svg/nut.svg?react";
import OrderingAsc from "./svg/ordering-asc.svg?react";
import OrderingDesc from "./svg/ordering-desc.svg?react";
import PanelLeft from "./svg/panel-left.svg?react";
import PaperPlane from "./svg/paper-plane.svg?react";
import Pdf from "./svg/pdf.svg?react";
import Pen from "./svg/pen.svg?react";
import Pencil from "./svg/pencil.svg?react";
import PerforatedSheet from "./svg/perforated-sheet.svg?react";
import Placeholder from "./svg/placeholder.svg?react";
import Plus from "./svg/plus.svg?react";
import Recommend from "./svg/recommend.svg?react";
import RectangularTube from "./svg/rectangular-tube.svg?react";
import Refresh from "./svg/refresh.svg?react";
import RotateLeft from "./svg/rotate-left.svg?react";
import RotateRight from "./svg/rotate-right.svg?react";
import RoundBar from "./svg/round-bar.svg?react";
import RoundTube from "./svg/round-tube.svg?react";
import Ruler from "./svg/ruler.svg?react";
import Save from "./svg/save.svg?react";
import Screenshot from "./svg/screenshot.svg?react";
import Search from "./svg/search.svg?react";
import Send from "./svg/send.svg?react";
import Settings from "./svg/settings.svg?react";
import ShapeTriangle from "./svg/shape-triangle.svg?react";
import Sheet from "./svg/sheet.svg?react";
import Slider from "./svg/slider.svg?react";
import SortDown from "./svg/sort-down.svg?react";
import SortUp from "./svg/sort-up.svg?react";
import Sort from "./svg/sort.svg?react";
import SquareBar from "./svg/square-bar.svg?react";
import SquareStack from "./svg/square-stack.svg?react";
import SquareTube from "./svg/square-tube.svg?react";
import StarFill from "./svg/star-fill.svg?react";
import Star from "./svg/star.svg?react";
import Stars from "./svg/stars.svg?react";
import Step from "./svg/step.svg?react";
import SubdirectoryRight from "./svg/subdirectory-right.svg?react";
import TearSheet from "./svg/tear-sheet.svg?react";
import Time from "./svg/time.svg?react";
import Trash from "./svg/trash.svg?react";
import TubeFolded from "./svg/tube-folded.svg?react";
import TubeStraight from "./svg/tube-straight.svg?react";
import WholeTube from "./svg/tube-straight.svg?react";
import Undo from "./svg/undo.svg?react";
import Upload from "./svg/upload.svg?react";
import User from "./svg/user.svg?react";
import Users from "./svg/users.svg?react";
import VectorBezier2 from "./svg/vector-bezier-2.svg?react";
import Weight from "./svg/weight.svg?react";
import Wrench from "./svg/wrench.svg?react";
import X from "./svg/x.svg?react";
import ZoomIn from "./svg/zoom-in.svg?react";
import ZoomOut from "./svg/zoom-out.svg?react";

const SIZE = 20;

export type IconName =
  | "addFile"
  | "addToQueue"
  | "alertTriangle"
  | "arrowBottom"
  | "arrowLeft"
  | "arrowRight"
  | "arrowUp"
  | "beam"
  | "billet"
  | "calendar"
  | "chat"
  | "check"
  | "chevronDown"
  | "chevronLeft"
  | "chevronRight"
  | "chevronUp"
  | "circle"
  | "circleAlert"
  | "circleCheck"
  | "circleError"
  | "circleFillAlert"
  | "circleFillCheck"
  | "circleFillError"
  | "circleFillInfo"
  | "circleHelp"
  | "circleInfo"
  | "circleMinus"
  | "code"
  | "comment"
  | "commentDetail"
  | "csv"
  | "cube"
  | "cylinder"
  | "detail"
  | "dislike"
  | "download"
  | "duplicate"
  | "edit"
  | "ellipsis"
  | "expand"
  | "export"
  | "fabera"
  | "factory"
  | "file"
  | "fileBlank"
  | "fileFind"
  | "fillDanger"
  | "filter"
  | "frame"
  | "fullscreen"
  | "grid"
  | "gripVertical"
  | "hammer"
  | "help"
  | "hintArrow"
  | "history"
  | "home"
  | "import"
  | "infoCircle"
  | "intersect"
  | "invoice"
  | "layer"
  | "layerPlus"
  | "layers3"
  | "layout"
  | "light"
  | "lightning"
  | "like"
  | "line"
  | "link"
  | "linkExternal"
  | "list"
  | "lock"
  | "logout"
  | "machining"
  | "mail"
  | "mailSend"
  | "map"
  | "menu"
  | "message"
  | "messageSquareEdit"
  | "minus"
  | "model"
  | "moreHorizontal"
  | "nut"
  | "orderingAsc"
  | "orderingDesc"
  | "panelLeft"
  | "paperPlane"
  | "pdf"
  | "pen"
  | "pencil"
  | "perforatedSheet"
  | "placeholder"
  | "plus"
  | "recommend"
  | "rectangularTube"
  | "refresh"
  | "rotateLeft"
  | "rotateRight"
  | "roundBar"
  | "roundTube"
  | "ruler"
  | "save"
  | "screenshot"
  | "search"
  | "send"
  | "settings"
  | "shapeTriangle"
  | "sheet"
  | "slider"
  | "sort"
  | "sortDown"
  | "sortUp"
  | "squareBar"
  | "squareStack"
  | "squareTube"
  | "star"
  | "starFill"
  | "stars"
  | "step"
  | "subdirectoryRight"
  | "tearSheet"
  | "time"
  | "trash"
  | "tubeFolded"
  | "tubeStraight"
  | "undo"
  | "upload"
  | "user"
  | "users"
  | "vectorBezier2"
  | "weight"
  | "weld"
  | "wholeTube"
  | "wrench"
  | "x"
  | "zoomIn"
  | "zoomOut";

type Props = {
  name: IconName;
  withBackground?: boolean;
  size?: number;
  color?: string;
  style?: CSSProperties;
};

const iconMap: Record<
  IconName,
  React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >
> = {
  addFile: AddFile,
  addToQueue: AddToQueue,
  alertTriangle: AlertTriangle,
  arrowBottom: ArrowBottom,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUp: ArrowUp,
  beam: Beam,
  billet: Billet,
  calendar: Calendar,
  chat: Chat,
  check: Check,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  circle: Circle,
  circleAlert: CircleAlert,
  circleCheck: CircleCheck,
  circleError: CircleError,
  circleFillAlert: CircleFillAlert,
  circleFillCheck: CircleFillCheck,
  circleFillError: CircleFillError,
  circleFillInfo: CircleFillInfo,
  circleHelp: CircleHelp,
  circleInfo: CircleInfo,
  circleMinus: CircleMinus,
  code: Code,
  comment: Comment,
  commentDetail: CommentDetail,
  csv: Csv,
  cube: Cube,
  cylinder: Cylinder,
  detail: Detail,
  dislike: Dislike,
  download: Download,
  duplicate: Duplicate,
  edit: Edit,
  ellipsis: Ellipsis,
  expand: Expand,
  export: Export,
  fabera: Fabera,
  factory: Factory,
  file: File,
  fileBlank: FileBlank,
  fileFind: FileFind,
  fillDanger: FillDanger,
  filter: Filter,
  frame: Frame,
  fullscreen: Fullscreen,
  grid: Grid,
  gripVertical: GripVertical,
  hammer: Hammer,
  help: Help,
  hintArrow: HintArrow,
  history: History,
  home: Home,
  import: Import,
  infoCircle: InfoCircle,
  intersect: Intersect,
  invoice: Invoice,
  layer: Layer,
  layerPlus: LayerPlus,
  layers3: Layers3,
  layout: Layout,
  light: Light,
  lightning: Lightning,
  like: Like,
  line: Line,
  link: Link,
  linkExternal: LinkExternal,
  list: List,
  lock: Lock,
  logout: Logout,
  machining: MachiningIcon,
  mail: Mail,
  mailSend: MailSend,
  map: Map,
  menu: Menu,
  message: Message,
  messageSquareEdit: MessageSquareEdit,
  minus: Minus,
  model: Model,
  moreHorizontal: MoreHorizontal,
  nut: Nut,
  orderingAsc: OrderingAsc,
  orderingDesc: OrderingDesc,
  panelLeft: PanelLeft,
  paperPlane: PaperPlane,
  pdf: Pdf,
  pen: Pen,
  pencil: Pencil,
  perforatedSheet: PerforatedSheet,
  placeholder: Placeholder,
  plus: Plus,
  recommend: Recommend,
  rectangularTube: RectangularTube,
  refresh: Refresh,
  rotateLeft: RotateLeft,
  rotateRight: RotateRight,
  roundBar: RoundBar,
  roundTube: RoundTube,
  ruler: Ruler,
  save: Save,
  screenshot: Screenshot,
  search: Search,
  send: Send,
  settings: Settings,
  shapeTriangle: ShapeTriangle,
  sheet: Sheet,
  slider: Slider,
  sort: Sort,
  sortDown: SortDown,
  sortUp: SortUp,
  squareBar: SquareBar,
  squareStack: SquareStack,
  squareTube: SquareTube,
  star: Star,
  starFill: StarFill,
  stars: Stars,
  step: Step,
  subdirectoryRight: SubdirectoryRight,
  tearSheet: TearSheet,
  time: Time,
  trash: Trash,
  tubeFolded: TubeFolded,
  tubeStraight: TubeStraight,
  undo: Undo,
  upload: Upload,
  user: User,
  users: Users,
  vectorBezier2: VectorBezier2,
  weight: Weight,
  weld: IconWaveSine,
  wholeTube: WholeTube,
  wrench: Wrench,
  x: X,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
};

export const Icon = forwardRef<HTMLDivElement, Props>(
  ({ name, withBackground, size = SIZE, color, style }, ref) => {
    const IconSvg = iconMap[name];

    return (
      <Box style={iconStyles(withBackground)} ref={ref}>
        <IconSvg width={size} height={size} color={color} style={style} />
      </Box>
    );
  },
);

const iconStyles = (withBackground: boolean | undefined) => ({
  backgroundColor: withBackground ? colors.blue[0] : "transparent",
  padding: withBackground ? spacing.xs : 0,
  borderRadius: radius.sm,
  display: "flex",
  alignItems: "center",
});
